export default "__VITE_ASSET__DFrI98QM__"